import { Skeleton } from "frontend-components";
import { useTranslation } from "react-i18next";
import { useIssuesStatusMetrics } from "./useIssuesStatusMetrics";

export default function IssuesStatusStats() {
    const { t } = useTranslation();
    const { total, active, closedPercentage, isLoading } = useIssuesStatusMetrics();

    if (isLoading) {
        return (
            <div className="divide-compendia-border grid grid-cols-3 divide-x">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="flex flex-col items-center gap-2 px-3 py-5">
                        <Skeleton className="bg-compendia-greige-60 h-9 w-16 rounded-full" />
                        <Skeleton className="bg-compendia-greige-60 h-3 w-20 rounded" />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="divide-compendia-border grid grid-cols-3 divide-x">
            <div
                className="flex flex-col items-center gap-1 px-3 py-5"
                title={t("common.tooltips.totalNumberOfIssues")}
            >
                <div className="text-text-primary text-3xl font-semibold tabular-nums">{total}</div>
                <p className="text-text-muted text-category tracking-category font-semibold uppercase">
                    {t("common.total")}
                </p>
            </div>

            <div
                className="flex flex-col items-center gap-1 px-3 py-5"
                title={t("common.tooltips.issuesInProgress")}
            >
                <div className="text-text-primary text-3xl font-semibold tabular-nums">
                    {active}
                </div>
                <p className="text-text-muted text-category tracking-category font-semibold uppercase">
                    {t("common.active")}
                </p>
            </div>

            <div
                className="flex flex-col items-center gap-1 px-3 py-5"
                title={t("common.tooltips.percentageOfClosedIssues")}
            >
                <div className="text-text-primary text-3xl font-semibold tabular-nums">
                    {Math.round(closedPercentage)}%
                </div>
                <p className="text-text-muted text-category tracking-category font-semibold uppercase">
                    {t("common.closed")}
                </p>
            </div>
        </div>
    );
}
